import React from 'react';

import {
    useClassifiedOfferDataLayerPush
} from '@search/vtbeco-frontend-core/domain/offer/analytics/ClassifiedOfferGtmContext';
import { useUserDetailsFetcher, useUserDetailsLoader } from '@search/auth/src/userDetails/userDetails';
import {
    minimalBanksMortgageUrlCreate
} from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/minimalBanksMortgageUrl';
import {
    useMortgageAppSource
} from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/MortgageAppSourceContext';
import { MortgagePurpose } from '@search/graphql-typings';
import {
    windowOpen
} from '@search/vtbeco-frontend-core/view/common/components/MinimalBanksMortgage/mortgage2/useMortgage2Request';
import { useM2AuthContext } from '@search/auth/src/M2AuthProvider';
import { UseAuthError } from '@search/auth/src/useAuth';
import { AuthInfo } from '@search/auth/src/AuthInfo';

const openOrAuth = (authInfo?: AuthInfo) => {
    return new Promise((resolve, reject) => {
        if (authInfo?.isAuthenticated) {
            resolve(null);
        } else {
            reject();
        }
    });
};

export const useMortgageAction = (props: {
    term: number;
    propertyCost: number;
    ownAmount: number;
    purpose: MortgagePurpose;
    regionId: number;
    isMobile?: boolean;
}) => {
    const dataLayerPush = useClassifiedOfferDataLayerPush();
    const sourceMortgage = useMortgageAppSource();
    const { waitAuth } = useM2AuthContext();
    const userDetailsFetcher = useUserDetailsFetcher();

    const userInfoLoad = useUserDetailsLoader();
    const userInfo = userInfoLoad({});

    const username = React.useRef(userInfo?.data?.userDetails?.username ?? null);
    const phone = React.useRef(userInfo?.data?.userDetails?.phone ?? null);

    const openLink = () => {
        const { fullUrl: minimalBanksMortgageUrl } = minimalBanksMortgageUrlCreate({
            isAuthenticated: true,
            ...props,
            mobilePhone: phone.current ?? undefined,
            fio: username.current!,
            source: sourceMortgage
        });

        dataLayerPush({ event: 'classified_card_sale_ipoteka_banks' });
        windowOpen(minimalBanksMortgageUrl, { isMobile: props.isMobile ?? false });
    };

    const goToMortgageApplication = React.useCallback(() => {
        dataLayerPush({ event: 'classified_card_sale_ipoteka_calc_click' });
        if (username.current && phone.current) {
            openLink();
        } else {
            waitAuth(
                authInfo => openOrAuth(authInfo)
                    .then(() => userDetailsFetcher())
                    .catch(() => {
                        throw new UseAuthError();
                    }),
                { phone: phone.current ?? undefined, continueAfterLogin: true }
            ).then(dataUserDetails => {
                username.current = dataUserDetails.data?.userDetails?.username ?? '';
                phone.current = dataUserDetails.data?.userDetails?.phone ?? '';

                openLink();
            }).catch(error => {
                throw new Error(error);
            });
        }
    }, [ openLink, userDetailsFetcher, waitAuth ]);

    return {
        goToMortgageApplication,
    };
};
